"use strict";
var appn;
(function (appn) {
    var designerv2;
    (function (designerv2) {
        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }
        class DesignerBase {
            constructor() {
                this._canSave = false;
                this._rootSnapshots = new Map();
                this._pathGuards = new Map();
            }
            run(args) {
                this.init(args);
                this.bindEvents();
                this.fetchAndLoadDesign(args);
            }
            init(args) {
                designerv2.designer = this;
                this._canSave = args.canSave;
                designerv2.autosave.init(args.canSave);
                designerv2.propertyPane.init('.propertyList', args.canSave);
                if (!designerv2.canvas)
                    throw new Error('Canvas needs to be assigned prior to init being called');
                designerv2.canvas.init(!args.canSave);
                designerv2.toolPane.init();
                this._designerJSONFieldName = args.designerJSONFieldName;
                $('.info-box-icon').smallipop({
                    preferredPosition: 'right',
                    theme: 'white info-box-icon',
                    popupOffset: 0,
                });
                if (!this._canSave) {
                    designerv2.eventBus.subscribe(designerv2.EVENTS.COMPONENT_SELECTED, () => {
                        setTimeout(() => this.setPropsToDisabledAndReadOnly(), 50);
                    });
                }
            }
            fetchAndLoadDesign(args) {
                const savedDesign = designerv2.autosave.getSavedDesign();
                const initialDesign = $('#designDef').data('def') || this.createDefaultDesign(args.name);
                if (!savedDesign || !args.canSave) {
                    this.render(initialDesign);
                    return;
                }
                appn.dialog.confirm({
                    modalColor: 'modal-info',
                    title: T('Load from Auto Save'),
                    message: T('An auto-saved version of this design was found. Load this instead?'),
                    callback: function (result) {
                        if (result) {
                            designerv2.designer.render(savedDesign);
                        }
                        else {
                            designerv2.autosave.clear();
                            designerv2.designer.render(initialDesign);
                        }
                    }
                });
            }
            render(design) {
                this.setDesign(design);
                designerv2.canvas.render(design);
                const selectedId = this._selectedComponentId;
                if (selectedId) {
                    this.setSelectedComponent(selectedId, true);
                    $(`#${selectedId}`).addClass('selected');
                }
                else {
                    const firstComponent = this._design.components.find(c => c.type);
                    if (firstComponent) {
                        this.setSelectedComponent(firstComponent.id, true);
                        $(`#${firstComponent.id}`).addClass('selected');
                    }
                }
                const getFlatComponents = (components) => {
                    return components.reduce((acc, comp) => {
                        acc.push(comp);
                        if (comp.children)
                            acc.push(...getFlatComponents(comp.children));
                        return acc;
                    }, []);
                };
                getFlatComponents(design.components).forEach(component => {
                    const definition = designerv2.componentManager.getDefinition(component.type);
                    if (definition) {
                        const dataQueryPropNames = designerv2.componentManager.getDataQueryPropertyNames(definition);
                        if (dataQueryPropNames.length > 0)
                            designerv2.eventBus.publish(designerv2.EVENTS.DATA_REFRESH_REQUESTED, { componentId: component.id });
                    }
                });
                $('.info-box-icon').smallipop({
                    preferredPosition: 'right',
                    theme: 'white info-box-icon',
                    popupOffset: 0,
                });
            }
            bindEvents() {
                $('body').on('click', '.focus-component', (e) => {
                    e.preventDefault();
                    const componentId = $(e.currentTarget).data('component-id');
                    this.setSelectedComponent(componentId);
                    appn.dialog.hide();
                });
                $('body').on('click', '#saveLink, .btn[name="submitType"]', function (e) {
                    e.preventDefault();
                    designerv2.designer.submit($(this).val() || 'Save');
                });
                $('.workspace').on('click', '.component.widget, .component.titleBar', function (e) {
                    e.stopPropagation();
                    const componentId = $(this).attr('id');
                    if (componentId) {
                        $('.component.selected').removeClass('selected');
                        $(this).addClass('selected');
                        designerv2.designer.setSelectedComponent(componentId);
                    }
                });
                $('.workspace').on('click', '.deleteComponent', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    const componentId = $(this).closest('.component').attr('id');
                    if (componentId) {
                        const handled = designerv2.canvas.removeComponent(componentId);
                        if (!handled)
                            designerv2.designer.deleteComponent(componentId);
                    }
                    return false;
                });
            }
            submit(submitType) {
                const validationErrors = this.validateDesign();
                if (validationErrors.length > 0) {
                    let message = `<p>${T('The design has validation errors. Please correct them before saving.')}</p>`;
                    message += '<ul class="validation-errors-list" style="max-height: 200px; overflow-y: auto; text-align: left;">';
                    validationErrors.forEach(err => {
                        const component = this.getComponent(err.componentId);
                        const definition = component ? designerv2.componentManager.getDefinition(component.type) : null;
                        const propDef = definition ? definition.properties[err.propName] : null;
                        const propDisplayName = propDef ? propDef.name : err.propName;
                        const componentName = (component === null || component === void 0 ? void 0 : component.name) || (component === null || component === void 0 ? void 0 : component.id) || T('Unknown Component');
                        err.errors.forEach(errorMsg => {
                            message += `<li><a href="#" class="focus-component" data-component-id="${err.componentId}">${componentName} (${propDisplayName}): ${T(errorMsg)}</a></li>`;
                        });
                    });
                    message += '</ul>';
                    appn.dialog.custom({
                        title: T('Cannot Save'),
                        message: message,
                        modalColor: 'modal-danger',
                        buttons: {
                            ok: {
                                label: T('OK'),
                                className: 'btn-danger'
                            }
                        }
                    });
                    return;
                }
                const design = this.getDesignForSave();
                const jsonString = JSON.stringify(design);
                const $form = $('form#appnForm');
                $form.find(`input[name="submitType"], input[name="${this._designerJSONFieldName}"]`).remove();
                $form.append($('<input type="hidden" name="submitType" />').val(submitType));
                $form.append($(`<input type="hidden" name="${this._designerJSONFieldName}" />`).val(jsonString));
                designerv2.autosave.clear();
                $form.submit();
            }
            setDesign(design) {
                const ensureDefaults = (components) => {
                    components.forEach(c => {
                        this.onEnsureDefaults(c);
                        if (c.children)
                            ensureDefaults(c.children);
                    });
                };
                ensureDefaults(design.components);
                this.normalizeLabelFromDataName(design);
                this._design = design;
                this.captureSnapshots(design.components);
                designerv2.eventBus.publish(designerv2.EVENTS.STATE_CHANGED, { design });
            }
            captureSnapshots(components) {
                components.forEach(component => {
                    this.captureComponentSnapshots(component);
                    if (component.children)
                        this.captureSnapshots(component.children);
                });
            }
            captureComponentSnapshots(component) { }
            onEnsureDefaults(component) {
                if (!component.id)
                    component.id = appn.utils.newGuid(true);
                component.id = appn.utils.normalizeIdentifier(component.id);
            }
            getDesignForSave() {
                if (!this._design)
                    return null;
                return appn.utils.deepClone(this._design);
            }
            snapshotRoot(componentId, rootPropName) {
                const component = this.getComponent(componentId);
                const captured = component ? appn.utils.deepClone(component[rootPropName]) : undefined;
                const snapshot = {
                    value: appn.utils.deepClone(captured),
                    restore: () => {
                        if (!this.getComponent(componentId))
                            return;
                        this.updateComponentProperty(componentId, rootPropName, appn.utils.deepClone(captured));
                    }
                };
                this._rootSnapshots.set(this.stateKey(componentId, rootPropName), snapshot);
                return snapshot;
            }
            getRootSnapshot(componentId, rootPropName) {
                return this._rootSnapshots.get(this.stateKey(componentId, rootPropName)) || null;
            }
            guardPath(componentId, path, holder) {
                const key = this.stateKey(componentId, path);
                this._pathGuards.set(key, holder);
                return {
                    release: () => {
                        if (this._pathGuards.get(key) === holder)
                            this._pathGuards.delete(key);
                    }
                };
            }
            canWritePath(componentId, path, holder) {
                const prefix = `${componentId}::`;
                for (const [key, guardedBy] of this._pathGuards) {
                    if (!key.startsWith(prefix))
                        continue;
                    const guardedPath = key.slice(prefix.length);
                    if (guardedBy !== holder && (path === guardedPath || path.startsWith(`${guardedPath}.`)))
                        return false;
                }
                return true;
            }
            stateKey(componentId, path) {
                return `${componentId}::${path}`;
            }
            getComponent(componentId) {
                if (!this._design || !componentId)
                    return null;
                const normalizedId = appn.utils.normalizeIdentifier(componentId);
                const find = (components) => {
                    for (const c of components) {
                        if (c.id === normalizedId)
                            return c;
                        if (c.children) {
                            const found = find(c.children);
                            if (found)
                                return found;
                        }
                    }
                    return null;
                };
                return find(this._design.components);
            }
            validateDesign() {
                const allErrors = [];
                const validateComponents = (components) => {
                    var _a;
                    for (const component of components) {
                        const definition = designerv2.componentManager.getDefinition(component.type);
                        if (definition) {
                            for (const propName in definition.properties) {
                                const propDef = definition.properties[propName];
                                if (!propDef.limit)
                                    continue;
                                let value = (_a = component[propName]) !== null && _a !== void 0 ? _a : propDef.defaultValue;
                                const errors = designerv2.editors.validateValue(value, propDef.limit);
                                if (errors.length <= 0)
                                    continue;
                                console.warn(`Validation error in component ${component.id}, property ${propName}:`, errors);
                                const errorObj = { componentId: component.id, propName: propName, errors: errors };
                                allErrors.push(errorObj);
                                designerv2.eventBus.publish(designerv2.EVENTS.ERROR_OCCURRED, errorObj);
                            }
                        }
                        if (component.children)
                            validateComponents(component.children);
                    }
                };
                if (this._design && this._design.components) {
                    validateComponents(this._design.components);
                }
                return allErrors;
            }
            getSelectedComponent() {
                return this._selectedComponentId ? this.getComponent(this._selectedComponentId) : null;
            }
            setSelectedComponent(componentId, forcePublish, onlySector) {
                const normalizedId = componentId ? appn.utils.normalizeIdentifier(componentId) : null;
                if (this._selectedComponentId === normalizedId && !forcePublish)
                    return;
                this._selectedComponentId = normalizedId;
                designerv2.eventBus.publish(designerv2.EVENTS.COMPONENT_SELECTED, { componentId: normalizedId, onlySector: onlySector });
            }
            addComponent(componentType, position) {
                const newComponent = designerv2.componentManager.createComponent(componentType);
                if (!newComponent || !this._design)
                    return null;
                newComponent.id = appn.utils.normalizeIdentifier(newComponent.id);
                newComponent.gridPosition = position;
                const group = this._design.components.find((c) => c.type === 'group');
                if (group && group.children)
                    group.children.push(newComponent);
                else
                    this._design.components.push(newComponent);
                this.assignUniqueNameAndLabel(newComponent);
                designerv2.autosave.markDirty();
                designerv2.eventBus.publish(designerv2.EVENTS.STATE_CHANGED, { design: this._design });
                return newComponent;
            }
            deleteComponent(componentId) {
                if (!this._design)
                    return;
                const normalizedId = appn.utils.normalizeIdentifier(componentId);
                const findAndDelete = (components) => {
                    const index = components.findIndex(c => c.id === normalizedId);
                    if (index > -1) {
                        components.splice(index, 1);
                        return true;
                    }
                    for (const c of components) {
                        if (c.children && findAndDelete(c.children))
                            return true;
                    }
                    return false;
                };
                if (findAndDelete(this._design.components)) {
                    if (this._selectedComponentId === normalizedId)
                        this.setSelectedComponent(null);
                    designerv2.autosave.markDirty();
                    designerv2.eventBus.publish(designerv2.EVENTS.STATE_CHANGED, { design: this._design });
                }
            }
            updateComponentProperty(componentId, propName, propValue, propPath) {
                const component = this.getComponent(componentId);
                if (!component)
                    return;
                const oldRoot = component[propName];
                let oldLeaf = oldRoot;
                let newLeaf = propValue;
                if (propPath) {
                    const pathParts = propPath.split('.');
                    const rootName = pathParts[0];
                    const pathWithinObject = pathParts.slice(1).join('.');
                    if (rootName === propName && pathWithinObject) {
                        oldLeaf = appn.designerv2.getPropertyByPath(oldRoot, pathWithinObject);
                        newLeaf = appn.designerv2.getPropertyByPath(propValue, pathWithinObject);
                    }
                }
                try {
                    const oldStr = JSON.stringify(oldLeaf);
                    const newStr = JSON.stringify(newLeaf);
                    if (oldStr === newStr)
                        return;
                }
                catch (_a) {
                    if (oldLeaf === newLeaf)
                        return;
                }
                component[propName] = propValue;
                const handlerOldValue = propPath ? oldRoot : oldLeaf;
                if (!this.onUpdateComponentProperty(component, propName, handlerOldValue, propPath))
                    return;
                designerv2.autosave.markDirty();
                designerv2.eventBus.propertyUpdated(component.id, propName, newLeaf, oldLeaf, propPath);
                designerv2.eventBus.publish(designerv2.EVENTS.STATE_CHANGED, { design: this._design });
            }
            updateComponentPosition(componentId, position) {
                const component = this.getComponent(componentId);
                if (component) {
                    component.gridPosition = position;
                    designerv2.autosave.markDirty();
                    designerv2.eventBus.publish(designerv2.EVENTS.STATE_CHANGED, { design: this._design });
                }
            }
            assignUniqueNameAndLabel(component) {
                var _a, _b;
                if (!component || !this._design)
                    return;
                if (component.type === appn.designerv2.BASE_COMPONENT_TYPE.GROUP)
                    return;
                const def = designerv2.componentManager.getDefinition(component.type);
                const baseTitle = ((def === null || def === void 0 ? void 0 : def.title) || 'Action').toString();
                const existingLabels = [];
                const stack = Array.isArray(this._design.components) ? this._design.components.slice() : [];
                while (stack.length) {
                    const c = stack.pop();
                    if (c && c.id !== component.id && c.type !== appn.designerv2.BASE_COMPONENT_TYPE.GROUP) {
                        const label = (_b = (_a = c.label) === null || _a === void 0 ? void 0 : _a.eng) === null || _b === void 0 ? void 0 : _b.trim();
                        if (label && label.length)
                            existingLabels.push(label);
                        else {
                            const d = designerv2.componentManager.getDefinition(c.type);
                            if (d === null || d === void 0 ? void 0 : d.title)
                                existingLabels.push(d.title.toString());
                        }
                    }
                    const ch = c === null || c === void 0 ? void 0 : c.children;
                    if (Array.isArray(ch) && ch.length)
                        stack.push(...ch);
                }
                let max = 0;
                let hasBase = false;
                for (const t of existingLabels) {
                    if (!t.startsWith(baseTitle))
                        continue;
                    if (t === baseTitle) {
                        hasBase = true;
                        max = Math.max(max, 1);
                        continue;
                    }
                    const m = t.match(/(\d+)$/);
                    if (m) {
                        const n = parseInt(m[1], 10);
                        if (!isNaN(n))
                            max = Math.max(max, n);
                    }
                }
                const finalTitle = (max > 0 || hasBase) ? `${baseTitle} ${max + 1}` : baseTitle;
                const dataName = this.toCamelCase(finalTitle);
                this.updateComponentProperty(component.id, 'label', { eng: finalTitle });
                this.updateComponentProperty(component.id, 'name', dataName);
            }
            normalizeLabelFromDataName(design) {
                var _a, _b, _c;
                const stack = Array.isArray(design.components) ? design.components.slice() : [];
                while (stack.length) {
                    const c = stack.pop();
                    if (!c || c.type === appn.designerv2.BASE_COMPONENT_TYPE.GROUP) {
                        const chSkip = c === null || c === void 0 ? void 0 : c.children;
                        if (Array.isArray(chSkip) && chSkip.length)
                            stack.push(...chSkip);
                        continue;
                    }
                    const def = designerv2.componentManager.getDefinition(c.type);
                    const baseTitle = ((def === null || def === void 0 ? void 0 : def.title) || '').toString();
                    const currentLabel = ((_b = (_a = c.label) === null || _a === void 0 ? void 0 : _a.eng) === null || _b === void 0 ? void 0 : _b.trim()) || '';
                    const dataName = (_c = c.name) === null || _c === void 0 ? void 0 : _c.trim();
                    const isDefaultLabel = currentLabel === '' || (baseTitle && currentLabel === baseTitle);
                    if (isDefaultLabel && baseTitle) {
                        if (!c.label)
                            c.label = { eng: '' };
                        if (dataName) {
                            const m = dataName.match(/(\d+)$/);
                            const num = m ? parseInt(m[1], 10) : null;
                            c.label.eng = num ? `${baseTitle} ${num}` : baseTitle;
                        }
                        else {
                            c.label.eng = baseTitle;
                        }
                    }
                    const ch = c === null || c === void 0 ? void 0 : c.children;
                    if (Array.isArray(ch) && ch.length)
                        stack.push(...ch);
                }
            }
            toCamelCase(str) {
                return (str || '')
                    .replace(/[^a-zA-Z0-9 ]/g, '')
                    .split(' ')
                    .map((w, i) => i === 0 ? w.toLowerCase() : (w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()))
                    .join('');
            }
            setPropsToDisabledAndReadOnly() {
                this.setPropsToReadonly();
                this.setPropsToDisabled();
            }
            setPropsToReadonly() {
                $('.propertyList').find('input[type="text"]:not(.js-no-disable),input[type="number"]:not(.js-no-disable),textarea:not(.js-no-disable)').each(function () {
                    $(this).attr('readonly', 'readonly');
                });
            }
            setPropsToDisabled() {
                $('.propertyList').find('input[type="radio"]:not(.js-no-disable),.displayButton:not(.js-no-disable),input[type="text"].colorPicker:not(.js-no-disable),input[type="text"].color:not(.js-no-disable),input[type="checkbox"]:not(.js-no-disable),select:not(.js-no-disable):not(#pageSelect):not(#SelectedDesignerLanguage),button:not(.js-no-disable),input[type="range"]:not(.js-no-disable),.buildIcon:not(.js-no-disable),a.btn:not(.js-no-disable),.removeLink:not(.js-no-disable),.removeBtn:not(.js-no-disable),.remove-projection:not(.js-no-disable),.remove-metric:not(.js-no-disable),.remove-sort-order:not(.js-no-disable),.remove-ref:not(.js-no-disable),.removeGroupBtn:not(.js-no-disable),.addCriterionToGroupBtn:not(.js-no-disable)').each(function () {
                    $(this).attr('disabled', 'disabled');
                });
                $('.propertyList').find('a.btn:not(.js-no-disable),.removeLink:not(.js-no-disable),.removeBtn:not(.js-no-disable),.remove-projection:not(.js-no-disable),.remove-metric:not(.js-no-disable),.remove-sort-order:not(.js-no-disable),.remove-ref:not(.js-no-disable),.removeGroupBtn:not(.js-no-disable),.addCriterionToGroupBtn:not(.js-no-disable)').each(function () {
                    $(this).addClass('disabled').attr('aria-disabled', 'true').on('click.disabled', (e) => e.preventDefault());
                });
                $('.propertyList').find('.minicolors-input:not(.js-no-disable)').each(function () {
                    try {
                        $(this).minicolors('settings', { readOnly: true });
                    }
                    catch (_a) { }
                });
            }
        }
        designerv2.DesignerBase = DesignerBase;
        class PlaceholderDesigner extends DesignerBase {
            createDefaultDesign(name) {
                throw new Error('Dummy designer in use?');
            }
            onUpdateComponentProperty(component, propName, oldValue, propPath) {
                return false;
            }
        }
        designerv2.designer = new PlaceholderDesigner();
    })(designerv2 = appn.designerv2 || (appn.designerv2 = {}));
})(appn || (appn = {}));
